import Vue from 'vue';
import global_mixin from './global_mixins.js'
import { searchTiles, searchSeries, bookmarkedTiles, tilesForColor } from '../graphql/queries'
import '../css/bookmarks.css'
var _ = require('lodash')

const app = new Vue({
  el: '#app',
  data() {
    return {}
  },
  apollo: {
    getTiles: {
      query: searchTiles,
      update: data => data.searchTiles,
      error (error) {
        if (error.name == 'InvariantError') {
          console.log('Invariant error found... wiping local cache!')
          this.$ls.remove('apollo-cache-persist')
        } else {
          console.error(error)
        }
      },
      variables() {
        return {
          filter: {
            "id": { "in": this.localBookmarkedTiles}
          }
        }
      },
      skip() {
        return !(this.cacheLoaded && (this.localBookmarkedTiles.length > 0))

      },
      watchLoading(isLoading) {
        this.isLoading = isLoading
      },
    },
    getSeries: {
      query: searchSeries,
      error (error) {
        if (error.name == 'InvariantError') {
          console.log('Invariant error found... wiping local cache!')
          this.$ls.remove('apollo-cache-persist')
        } else {
          console.error(error)
        }
      },
      update: data => data.searchSeries,
      variables() {
        return {
          filter: {
            "id": { "in": this.localBookmarkedSeries }
          }
        }
      },
      skip() {
        return !(this.cacheLoaded && (this.localBookmarkedSeries.length > 0))
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading
      },
    },
    /*getSamples: {
      query: searchTiles,
      error (error) {
        if (error.name == 'InvariantError') {
          console.log('Invariant error found... wiping local cache!')
          this.$ls.remove('apollo-cache-persist')
        } else {
          console.error(error)
        }
      },
      update: data => data.searchTiles,
      variables() {
        return {
          filter: {
            "id": { "in": this.bookmarked_sampleorder_skus }
          }
        }
      },
      skip() {
        return (this.bookmarked_sampleorder_skus.length == 0)
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading
      },
    },*/
    bookmarkedTiles: {
      query: bookmarkedTiles,
      update: data => data.allTiles,
      result({ data, loading, networkStatus }) {
        data = data.allTiles
        this.sampleOrders = []
        this.$ls.set('bookmarked_sampleorder_skus', JSON.stringify(Array.from(new Set(this.bookmarked_sampleorder_skus))))
        if (data.edges && data.edges.length > 0) {
          for (const tile of data.edges) {
            if (_.find(this.sampleOrders, { 'sku': tile.node.sku }) === undefined) {
              this.addSampleToCart(tile.node)
            }
          }
        }
      },
      variables() {
        return {
          id: this.encodedBookmarks,
        }
      },
      error(error) {
        if (error.name == 'InvariantError') {
          console.log('Invariant error found... wiping local cache!')
          this.$ls.remove('apollo-cache-persist')
        }
        else {
          console.error(error)
        }
      },
      skip() {
        return !(this.cacheLoaded && this.encodedBookmarks.length > 0)
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading
      },
    },
    tilesForColor: {
      query: tilesForColor,
      update: data => data.allColors,
      error(error) {
        if (error.name == 'InvariantError') {
          console.log('Invariant error found... wiping local cache!')
          this.$ls.remove('apollo-cache-persist')
        }
        else {
          console.error(error)
        }
      },
      variables() {
        return {
          id: this.uniqueColorLookups,
          unavailableForSampleOrder: false,
          excludeCutSample: false
        }
      },
      skip() {
        return this.uniqueColorLookups.length === 0
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading
      },
    },
  },
  methods: {},

  computed: {
    encodedBookmarks() {
      let bookmarks = []
      for (const bookmark of this.bookmarked_sampleorder_skus) {
        bookmarks.push(this.encodeTileID(bookmark))
      }
      return bookmarks
    },
    orderedSKUList() {
      let skuList = []
      for (const order of this.sampleOrders) {
        skuList.push(order.sku)
      }
      return skuList
    },
    orderedQuantityList() {
      let skuList = []
      if (this.quantityUpdated) {
        for (const order of this.sampleOrders) {
          skuList.push((order.quantity) ? order.quantity : 1)
        }
        this.quantityUpdated = false
      }
      return skuList
    },
    totalSamples() {
      return this.orderedQuantityList.reduce((a, b) => a + b, 0)
    },
    groupedTilesForColor() {
      let groupedData = []
      if (this.tilesForColor && this.tilesForColor.edges) {
        groupedData = _.groupBy(this.tilesForColor.edges, (e) => { return e.node.id })
      }
      return groupedData
    },
    uniqueColorLookups() {
      return _.uniq(this.colorLookups)
    },
    /*bookmarked_sample_orders() {
      let data = []
      if (this.getSamples) {
        for (const element of this.getSamples.edges) {
          data.push({
            id: this.decodeRelayID(element.node.id),
            image: element.node.publicThumbnail,
            sku: element.node.sku
          })
        }

      }
      return data
    },*/
    bookmarked_seriesid() {
      let data = []
      if (this.getSeries && (this.localBookmarkedSeries.length > 0)) {
        for (const element of this.getSeries.edges) {
          data.push({
            image: element.node.image,
            id: this.decodeRelayID(element.node.id),
            url: element.node.url,
            name: element.node.name,
            category: element.node.category,
            body_composition: element.node.bodyComposition
          })
        }
      }
      return data
    },
    bookmarked_tilesid() {
      let data = []
      if (this.getTiles && (this.localBookmarkedTiles.length > 0)) {
        for (const element of this.getTiles.edges) {
          data.push({
            id: this.decodeRelayID(element.node.id),
            thumbnail: element.node.publicThumbnail,
            color: element.node.color.name,
            seriesURL: element.node.seriesUrl,
            series: element.node.series.name,
            category: element.node.series.category,
            size: element.node.shape.size,
            sku: element.node.sku,
            unavailableForSampling: element.node.unavailableForSampleOrder,
            sampleId: element.node.sampleId//element.node.
          })
        }

      }
      return data
    }
  },
  created() {
    this.loadBookmarks()
  },
  mixins: [global_mixin]
});



// WEBPACK FOOTER //
// ./core/vue/js/bookmarks.js